export const withStopPropagation = ( fn = () => {} ) => ( event ) => {
  event.stopPropagation()
  fn( event )
}

export const withPreventDefault = ( fn = () => {} ) => ( event ) => {
  event.preventDefault()
  fn( event )
}
